module.exports = __webpack_public_path__ + "media/img/avatars/profiles/standard1-101631bb2d14756e48dc9a1b3bcb6e29.jpg";